import React from 'react';
import styled from 'styled-components';

const ErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f8f9fa;
`;

const ErrorMessage = styled.div`
  background-color: #ffebee;
  border: 1px solid #f44336;
  border-radius: 8px;
  padding: 2rem;
  text-align: center;
  max-width: 500px;
`;

const ErrorPage: React.FC = () => {
  return (
    <ErrorContainer>
      <ErrorMessage>
        <h1>Page non trouvée</h1>
        <p>La page que vous recherchez n'existe pas.</p>
      </ErrorMessage>
    </ErrorContainer>
  );
};

export default ErrorPage;
